import { useEffect } from 'react'
import { linkToBorrowerApp } from '../../libs/linkToBorrowerApp'

export const NotFound = () => {
  useEffect(() => {
    window.location.replace(linkToBorrowerApp('/not-found'))
  }, [])

  return null
}